import React from "react";
import { NAUTICALPDBLUE } from "../../../../../constants";
import ResignNauticalBlueText from "./ResignNauticalBlueText";
import ResignNauticalRedText from "./ResignNauticalRedText";

const ResignNauticalCheckboxes = ({ nauticalPdColor, disableAll }) => {
  return (
    <>
      {nauticalPdColor === NAUTICALPDBLUE ? (
        <ResignNauticalBlueText disableAll={disableAll} />
      ) : (
        <ResignNauticalRedText disableAll={disableAll} />
      )}
    </>
  );
};

export default ResignNauticalCheckboxes;
